import { type FC, useEffect } from 'react'

import { ProductCarouselGalleryWithThumbnails } from '../ProductCarouselGalleryWithThumbnails'
import { useOptionalProductCarouselFocus } from '../ProductCarouselGalleryWithThumbnails/ProductCarouselFocusContext'

import { type ProductCarouselLargeGalleryProps } from './ProductCarouselLargeCarouselProps'

const ProductCarouselLargeCarousel: FC<ProductCarouselLargeGalleryProps> = ({
  images,
  initialIndex,
  isOpen,
  playVideoOnScrolledIntoView,
  productName,
  videos,
}) => {
  const focusContext = useOptionalProductCarouselFocus()

  useEffect(() => {
    if (isOpen) {
      focusContext?.focusItem(initialIndex)
    }
  }, [isOpen, initialIndex, focusContext])

  return (
    <div
      className="relative mx-7 flex max-w-2xl flex-1 flex-col items-center justify-center"
      data-qa-id="product-large-gallery"
    >
      <ProductCarouselGalleryWithThumbnails
        images={images}
        initialImageIndex={initialIndex}
        largeCarouselBadgesGroup
        playVideoOnClick
        playVideoOnScrolledIntoView={playVideoOnScrolledIntoView}
        productName={productName}
        thumbnails="dotted"
        useLargeImageSizes
        videos={videos}
        withLeftRightButtons
      />
    </div>
  )
}

export { ProductCarouselLargeCarousel }
